module.exports = __webpack_public_path__ + "static/media/9-8.98fb3e8d.mp3";